import React from 'react';
import Autocomplete from 'react-autocomplete';

const menuStyle = {
  position: 'absolute',
  left: '0',
  top: '100%',
  maxHeight: '350px',
  overflow: 'auto',
  border: '1px solid #cccccc',
};

const inputProps = {
  className: 'form-control awesomplete pillSelct-input',
  name: 'colaborador',
};

const ConfirmarInformacion = props => (
  <div>
    <div className='newAut-slides-item'>
      <div className='row'>
        <div className='col-xs-8'>
          <h4 className='bold'>{typeof(props.fichaVenta.nomPerso)!=='undefined'
            ?props.fichaVenta.nomPerso
            :props.fichaVenta.nomCliente}</h4>
        </div>
        <div className='col-xs-4'>
          <p className='labelInfo'>N° Ficha de Venta</p>
          <p className='lead'>{props.fichaVenta.numFichaVtaVeh}</p>
        </div>
      </div>
      <div className='row mt-3'>
        <div className='col-xs-6'>
          <p className='labelInfo'>Tipo de solicitud</p>
          <p>{props.solicitud.descTipoSolicitud}</p>
        </div>
        <div className='col-xs-6'>
          <p className='labelInfo'>F° Est. de Regul.</p>
          <p>{props.solicitud.fechaExcep.format('DD/MM/YYYY')}</p>
        </div>
        {
          props.solicitud.pedidos.length === 0 &&
            <div className='col-xs-6'>
              <p className='labelInfo'>Cant. Unidades</p>
              <p>{props.solicitud.nvehi}</p>
            </div>
        }
        <div className='col-xs-6'>
          <p className='labelInfo'>Resp.de la regularización</p>
          <p>{props.solicitud.responsableID}</p>
        </div>
        <div className='col-xs-12'>
          <p className='labelInfo'>Observaciones</p>
          <p>{props.solicitud.obsExcep}</p>
        </div>
      </div>
      {
        props.solicitud.pedidos.length > 0 &&
          <div className="row">
            <div className="col-xs-12">
              <p className="labelInfo">N° de Pedidos</p>
              <p>{props.solicitud.pedidos.toString()}</p>
            </div>
          </div>
      }
      <hr className='dark' />
      <div className='newAut-notify'>
        <p className='labelInfo'>Notificar a:</p>
        <div className='newAut-notify-contacts'>
          {
            props.colaboradoresSeleccionados.map(colaborador => (
              <label className='pill pill-cyan pillSelct-pills-item' htmlFor='colaborador'>
                {colaborador.nombres}
                <button
                  className='pillSelct-delete'
                  onClick={() => props.removeColaborador(colaborador.id)}
                ><i className='icon ion-close pill-close' />
                </button>
              </label>
            ))
          }
        </div>
        <Autocomplete
          getItemValue={item => item.idUsuario.toString()}
          value={props.colaborador}
          items={props.colaboradores}
          renderItem={(item, isHighlighted) =>
            <div key={item.idUsuario} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
              {`${item.apellidos} ${item.nombre}`}
            </div>
          }
          onChange={props.changeColaborador}
          menuStyle={menuStyle}
          inputProps={inputProps}
          wrapperStyle={{ display: 'block', position: 'relative' }}
          onSelect={props.selectColaborador}
        />
      </div>
      <div className='modal-actions'>
        <button className='btn btn-default' onClick={props.prevStep}>Anterior</button>
        <button className='btn btn-primary pull-right' onClick={props.addSolicitud}>{props.textButton}</button>
      </div>
    </div>
  </div>
);

export default ConfirmarInformacion;



// WEBPACK FOOTER //
// ./src/pages/modals/SolicitudExcepcional/ConfirmarInformacion.js